import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { Logo } from "@/components/site/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grain-band opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo light /></div>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-11 w-11 rounded-xl bg-emerald-brand/10 text-emerald-brand flex items-center justify-center"><Mail size={20} /></span>
            <div><h1 className="font-display font-semibold text-xl text-navy">Forgot Password</h1><p className="text-sm text-slate-500">We'll email you a reset link</p></div>
          </div>
          {sent ? (
            <div data-testid="forgot-sent" className="space-y-4">
              <p className="text-sm text-slate-600 bg-emerald-brand/5 border border-emerald-brand/30 rounded-lg px-4 py-3">If an admin account exists for <strong>{email}</strong>, a password reset link has been sent. Please check your inbox (the link expires in 1 hour).</p>
              <Button onClick={() => navigate("/admin/login")} className="w-full bg-emerald-brand hover:bg-emerald-dark rounded-full py-6 font-semibold">Back to Login</Button>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form" className="space-y-5">
              <div><Label>Admin Email</Label><Input required type="email" data-testid="forgot-email" className="mt-1.5 focus-visible:ring-emerald-brand" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-emerald-brand hover:bg-emerald-dark rounded-full py-6 font-semibold">{loading ? "Sending…" : "Send Reset Link"}</Button>
              <button type="button" onClick={() => navigate("/admin/login")} className="w-full inline-flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-navy"><ArrowLeft size={15} /> Back to login</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
